(function () {
  var ADD_URL = (window.routes && window.routes.cart_add_url) || '/cart/add';

  function setState(btn, state) {
    btn.dataset.state = state;
    if (state === 'added') {
      btn.classList.add('is-added');
      setTimeout(function () {
        btn.classList.remove('is-added');
        btn.dataset.state = 'idle';
      }, 1600);
    }
  }

  function refreshCartUI() {
    var sections = [];
    if (document.querySelector('cart-drawer')) sections.push('cart-drawer');
    if (document.getElementById('cart-icon-bubble')) sections.push('cart-icon-bubble');
    if (!sections.length) return;

    fetch('?sections=' + sections.join(','))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        Object.keys(data).forEach(function (key) {
          var target =
            key === 'cart-icon-bubble'
              ? document.getElementById('cart-icon-bubble')
              : document.querySelector('cart-drawer');
          if (!target) return;
          var parsed = new DOMParser().parseFromString(data[key], 'text/html');
          var incoming =
            key === 'cart-icon-bubble'
              ? parsed.getElementById('cart-icon-bubble')
              : parsed.querySelector('cart-drawer');
          if (incoming) target.innerHTML = incoming.innerHTML;
        });
      })
      .catch(function () {});
  }

  function addToCart(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId || btn.dataset.state === 'busy') return;

    setState(btn, 'busy');

    fetch(ADD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function () {
        setState(btn, 'added');
        refreshCartUI();
      })
      .catch(function () {
        setState(btn, 'idle');
      });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.samhain-bag-btn');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    addToCart(btn);
  });
})();
